import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGearComplexCode, faXmark, faRefresh } from '@fortawesome/pro-light-svg-icons';
import { toast, ToastContentProps } from 'react-toastify';
import { trpc } from '../../utils/trpc-client';
import { build } from '../../utils/build';

export function useCheckForNewVersion() {
  const { data: buildInfo } = trpc.buildInfo.useQuery(undefined, {
    refetchInterval: 60000 // check every minute
  });

  useEffect(() => {
    if (buildInfo && buildInfo.version != build.version) {
      showUpdateAvailableToast();
    }
  }, [buildInfo]);
}

function showUpdateAvailableToast() {
  toast(toastProps => <UpdateAvailableToast {...toastProps} />, { toastId: 'refresh-page-toast' });
}

type Props = {} & ToastContentProps;

function UpdateAvailableToast({ closeToast }: Props) {
  return (
    <div className="flex items-center rounded-lg bg-blue-300 p-2">
      <FontAwesomeIcon icon={faGearComplexCode} className="h-7 w-7 px-2 text-blue-600" />
      <div className="flex flex-1 items-center justify-between gap-4 rounded-lg bg-blue-200 p-2 pl-4">
        <div className="flex flex-col text-gray-800">
          <div className="mb-1 flex items-center justify-between font-semibold">
            <span>An update to Bravo is available</span>
          </div>
          <div className="text-sm">Refresh the page to apply it.</div>
        </div>
        <div className="flex flex-col items-end justify-between gap-1">
          <div
            className="flex cursor-pointer rounded-sm bg-blue-300 px-1 py-0.5"
            onClick={closeToast}>
            <FontAwesomeIcon size="lg" className="text-gray-600" icon={faXmark} />
          </div>

          <div
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-sm border border-blue-400 bg-white p-1 pl-3 pr-3 text-sm text-blue-600"
            onClick={() => window.location.reload()}>
            <FontAwesomeIcon className="text-blue-600" icon={faRefresh} />
            Refresh page
          </div>
        </div>
      </div>
    </div>
  );
}
